import React, {useState} from "react";
import {IconButton, InputAdornment, TextField} from "@mui/material";
import {useFormContext} from "react-hook-form";
import {Visibility, VisibilityOff} from "@mui/icons-material";
import {useLxTranslations} from "@lxo-blocks/react";
import {CREDENTIALS_FORM_TRANSLATION} from "./CredentialsForm.translation.de";

export const PasswordFormInput = React.forwardRef<any, any>((props, ref) => {
    const {t} = useLxTranslations(CREDENTIALS_FORM_TRANSLATION);
    const [passwordVisible, setPasswordVisible] = useState(false);
    const {errors} = useFormContext();
    return (
        <TextField
            {...props}
            ref={ref}
            fullWidth
            type={passwordVisible ? "input" : "password"}
            label={t("PASSWORD")}
            error={!!errors.password}
            helperText={
                errors.password?.message
            }
            variant="outlined"
            inputProps={{
                "aria-label": "password"
            }}
            InputProps={{
                endAdornment: (
                    <InputAdornment position="end">
                        <IconButton
                            onClick={() => setPasswordVisible(!passwordVisible)}
                            size="large">
                            {passwordVisible ? <Visibility/> : <VisibilityOff/>}
                        </IconButton>
                    </InputAdornment>
                ),
            }}
            autoFocus={props.autoFocus}
        />
    );
});
